import React from "react";

interface Props { }

export const LoaderIconComponent: React.SFC<Props> = () => {
  return (
    // tslint:disable:max-line-length
    <svg width="100%" height="100%" viewBox="0 0 50 50">
      <defs>
        <linearGradient id="gradientFill">
          <stop offset="0%" stopColor="white" stopOpacity="0" />
          <stop offset="100%" stopColor="white" />
        </linearGradient>
      </defs>
      <path fill="url(#gradientFill)" d="M25,5A20.14,20.14,0,0,1,45,22.88a2.51,2.51,0,0,0,2.49,2.26h0A2.52,2.52,0,0,0,50,22.33a25.14,25.14,0,0,0-50,0,2.52,2.52,0,0,0,2.5,2.81h0A2.51,2.51,0,0,0,5,22.88,20.14,20.14,0,0,1,25,5Z">
        <animateTransform attributeName="transform" type="rotate" dur="0.7s" repeatCount="indefinite" from="0 25 25" to="360 25 25" />
      </path>
    </svg>
    // tslint:enable:max-line-length
  );
};
